import {gql} from "graphql-request";
import GraphQL from "@app/model/_common/service/GraphQL";

export const SEARCH_HOTELS_QUERY: GraphQL = {
    name: "searchHotels",
    gql: gql`
        query searchHotels($term: String!) {
            searchHotels(term: $term) {
                id
                name
                address
                countryName
                coordinates {
                    lat
                    lng
                }
            }
        }
    `
}